window.Swiper6 = window.Swiper;